import React from "react";
import ProductsPage from "./../components/Products/ProductsPage";

const Product = () => {
  return (
    <div>
      <ProductsPage />
    </div>
  );
};

export default Product;
